// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-55f8f4de] {\n  background: var(--magic-light, #fff);\n  color: #2b2b2b;\n}\n@media (min-width: 768px) {\n  .content[data-v-55f8f4de] {\n    left: calc(var(--magic-space--small, 8px) * -1);\n    width: calc(100% + var(--magic-space, 16px));\n  }\n}\n.content[data-v-55f8f4de]::before {\n  border-color: transparent transparent #fff transparent;\n}\n\n.icon[data-v-55f8f4de] {\n  color: var(--magic-tertiary, #311261);\n}", ""]);
// Exports
module.exports = exports;
